
















import { defineComponent, computed } from '@vue/composition-api';
import sl from '@/serviceLocator';

export default defineComponent({
  props: {
    message: {
      type: String,
      required: false,
    },
  },
  setup() {
    const store = sl.get('store');

    const isAuthenticated = computed(() => store.getters.isAuthenticated);

    return {
      isAuthenticated,
    };
  },
});
